import React from "react";
import ProductCard from "./ProductsCard";
import "./ProductList.css";
import { Nut } from "../../../../images/Images";

const products = [
  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },

  {
    image: Nut,
    name: "Groundnut",
    price: 12.11,
    stock: 100,
  },
  {
    image: Nut,
    name: "Fresh Tomatoes",
    price: 5.13,
    stock: 100,
  },
];

const ProductList: React.FC = () => {
  return (
    <div className="retail-product-list">
      <h2 className="retail-product-list__title">Featured Products</h2>
      <div className="retail-product-list__grid">
        {products.map((product, index) => (
          <ProductCard key={index} {...product} />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
